export default function HowItWorks() {
  const steps = [
    {
      number: 1,
      title: 'Choose Your Event',
      icon: 'ri-search-line',
    },
    {
      number: 2,
      title: 'Follow Required Accounts',
      icon: 'ri-user-add-line',
    },
    {
      number: 3,
      title: 'Get Your Ticket',
      icon: 'ri-ticket-line',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border-2 border-purple-200 mb-6 sm:mb-8">
              <i className="ri-sparkling-line text-purple-600"></i>
              <span className="text-sm font-semibold text-purple-600">How It Works</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
              <span className="text-gray-900">Attend Events.</span>
              <br />
              <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                Grow Your Socials.
              </span>
              <br />
              <span className="text-gray-900">Win-Win.</span>
            </h2>

            <p className="text-base sm:text-lg text-gray-700 mb-8 sm:mb-12 leading-relaxed max-w-lg">
              Our unique platform connects event organizers with attendees through social engagement. 
              Follow select accounts to unlock event access, creating mutual value for everyone involved.
            </p>

            <div className="space-y-3 sm:space-y-4">
              {steps.map((step) => (
                <div
                  key={step.number}
                  className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow"
                >
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-base sm:text-lg">
                    {step.number}
                  </div>
                  <span className="text-sm sm:text-base font-semibold text-gray-800">{step.title}</span>
                  <i className={`${step.icon} text-lg sm:text-xl text-purple-600 ml-auto`}></i>
                </div>
              ))}
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative z-10">
              <img
                src="https://public.readdy.ai/ai/img_res/4bebe0f6484a3f191dd492c3e67d1068.jpg"
                alt="How it works illustration"
                className="w-full h-auto rounded-2xl"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-purple-300 rounded-full blur-3xl opacity-30"></div>
            <div className="absolute -top-8 -right-8 w-64 h-64 bg-pink-300 rounded-full blur-3xl opacity-30"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
